import type { AffixDef, ComponentDef } from "./schemas";

export const AFFIXES: AffixDef[] = [
  {
    id: "hot_barrels",
    name: "Hot Barrels",
    description: "+18% weapon damage, +10% cooldown",
    incompatibleWith: ["coolant_loop"],
    effects: { damageMult: 1.18, cooldownMult: 1.1 },
  },
  {
    id: "coolant_loop",
    name: "Coolant Loop",
    description: "-15% cooldown, -8% damage",
    incompatibleWith: ["hot_barrels"],
    effects: { cooldownMult: 0.85, damageMult: 0.92 },
  },
  {
    id: "scrap_magnet",
    name: "Scrap Magnet",
    description: "+25% salvage from drops",
    incompatibleWith: [],
    effects: { salvageMult: 1.25 },
  },
  {
    id: "hard_shell",
    name: "Hard Shell",
    description: "+20% max shield",
    incompatibleWith: ["glass_cannon"],
    effects: { shieldMult: 1.2 },
  },
  {
    id: "glass_cannon",
    name: "Glass Cannon",
    description: "+30% damage, -25% shield",
    incompatibleWith: ["hard_shell"],
    effects: { damageMult: 1.3, shieldMult: 0.75 },
  },
  {
    id: "afterburn_trim",
    name: "Afterburn Trim",
    description: "+12% speed",
    incompatibleWith: [],
    effects: { speedMult: 1.12 },
  },
  {
    id: "nap_predator",
    name: "Pressure Predator",
    description: "+10% weapon damage",
    incompatibleWith: [],
    effects: { damageMult: 1.1 },
  },
  {
    id: "high_lane",
    name: "Velocity Line",
    description: "+10% speed",
    incompatibleWith: [],
    effects: { speedMult: 1.1 },
  },
  {
    id: "thrifty_boost",
    name: "Thrifty Boost",
    description: "Slight speed edge when scavenging",
    incompatibleWith: [],
    effects: { speedMult: 1.05, salvageMult: 1.05 },
  },
  {
    id: "shield_weave",
    name: "Shield Weave",
    description: "+12% shield, -5% speed",
    incompatibleWith: ["glass_cannon"],
    effects: { shieldMult: 1.12, speedMult: 0.95 },
  },
  {
    id: "breach_tuned",
    name: "Breach Tuned",
    description: "+20% damage",
    incompatibleWith: ["coolant_loop"],
    effects: { damageMult: 1.2 },
  },
  {
    id: "loot_courier",
    name: "Loot Courier",
    description: "+35% salvage, -8% damage",
    incompatibleWith: ["glass_cannon"],
    effects: { salvageMult: 1.35, damageMult: 0.92 },
  },
];

export const COMPONENTS: ComponentDef[] = [
  {
    id: "plate_kit",
    name: "Plate Kit",
    description: "+20 hull",
    effects: { hullBonus: 20 },
  },
  {
    id: "capacitor_bank",
    name: "Capacitor Bank",
    description: "+15 shield",
    effects: { shieldBonus: 15 },
  },
  {
    id: "boost_cell",
    name: "Boost Cell",
    description: "+25% boost fuel",
    effects: { boostBonus: 0.25 },
  },
  {
    id: "beacon_link",
    name: "Beacon Link",
    description: "Faster extract channel",
    effects: { extractBonus: 0.35 },
  },
];

export function canAddAffix(owned: readonly string[], nextId: string): boolean {
  const next = AFFIXES.find((a) => a.id === nextId);
  if (!next) return false;
  if (owned.includes(nextId)) return false;
  if (owned.length >= 4) return false;
  return !owned.some((id) => next.incompatibleWith.includes(id));
}
